import styles from './EnneagramKnowType.module.scss'
import { fetchV3ApiAuthed } from '@crystal-eyes/utils/apis/v3Api'
import logger from '@crystal-eyes/utils/logger'
import useAssessments from '@crystal-eyes/hooks/profiles/personality/useAssessments'
import Card from '@dashboard/components/Card'
import useAuth from '@crystal-eyes/hooks/useAuth'
import EnneagramSVG from '@dashboard/components/EnneagramSVG'
import type { DiscType } from '@crystal-eyes/types'

interface Identity {
  id: string
  snapshot?: {personality?: {discType: DiscType}}
}

type ENNEAGRAM_TYPES = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9'

const EnneagramKnowType = ({
  onFinish,
  identity,
}: {
  onFinish?: () => void
  identity?: Identity
}) => {
  const { data: auth } = useAuth()
  const { refresh } = useAssessments({ identity })
  const discType = identity?.snapshot?.personality?.discType || 'empty'
  const submitAssessment = async (type: ENNEAGRAM_TYPES) => {
    logger.info('Submitting Enneagram Known Type', type)
    return fetchV3ApiAuthed(auth, 'enneagram', {
      method: 'POST',
      body: JSON.stringify({
        text_type: type,
      }),
    })
      .then(() => {
        return refresh()
      })
      .finally(() => {
        if (onFinish) onFinish()
      })
  }
  return (
    <div className={styles.container}>
      <Card title="Select Enneagram Type" plain center paddedTitle>
        <div className={styles.imgSubtitle}>
          If you already know your Enneagram type, select it below.
        </div>
        <div className={styles.imgGrid}>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('1')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="1" discType={discType} width="100%" />
            </div>
            Type 1
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('2')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="2" discType={discType} width="100%" />
            </div>
            Type 2
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('3')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="3" discType={discType} width="100%" />
            </div>
            Type 3
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('4')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="4" discType={discType} width="100%" />
            </div>
            Type 4
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('5')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="5" discType={discType} width="100%" />
            </div>
            Type 5
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('6')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="6" discType={discType} width="100%" />
            </div>
            Type 6
          </div>

          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('7')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="7" discType={discType} width="100%" />
            </div>
            Type 7
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('8')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="8" discType={discType} width="100%" />
            </div>
            Type 8
          </div>
          <div
            className={`${styles.enneagramImg} ${discType}`}
            onClick={() => submitAssessment('9')}
          >
            <div className={styles.svgContainer}>
              <EnneagramSVG type="9" discType={discType} width="100%" />
            </div>
            Type 9
          </div>
        </div>
      </Card>
    </div>
  )
}

export default EnneagramKnowType
